export default "__VITE_ASSET__B780owWs__"